import { styled } from "styled-components";

export const SignUpModalMessage = styled.div`
  font-size: 24px;
`;
